module.exports = __webpack_public_path__ + "static/media/ransomware.83009071.jpg";